import Big from "big.js";

const urlFunction = () => {
  const env = process.env.NODE_ENV;
  if (env === "development") {
    return "http://10.0.0.13:3001/api/v1";
  } else {
    return "https://api.haybroker.app/api/v1";
  }
};

const baseUrlFunction = () => {
  const env = process.env.NODE_ENV;
  if (env === "development") {
    return "http://10.0.0.13:3001";
  } else {
    return "https://api.haybroker.app";
  }
};

const domainUrlFunction = () => {
  const env = process.env.NODE_ENV;
  if (env === "development") {
    return "10.0.0.13:3001";
  } else {
    return "api.haybroker.app";
  }
};

export const BLANK_EDITOR_DOCUMENT = {
  type: "doc",
  content: [
    {
      type: "paragraph",
      content: [],
    },
  ],
};

export const POUNDS_PER_TONS = 2000;
export const CALC_POUNDS_PER_TONS = new Big(2000);

export const API_URL = urlFunction();
export const BASE_URL = baseUrlFunction();
export const DOMAIN_URL = domainUrlFunction();
